<template>
  <div class="market-giftCouponList-add">

    <el-form ref="form" :model="form" :rules="rules" hide-required-asterisk label-width="100px">
      <div class="base-config">
        <el-form-item label="券来源" prop="issueType">
          <el-radio-group v-model="form.issueType" :disabled="$route.query.id">
            <el-radio label="Auto">闰土自制</el-radio>
            <el-radio label="Stock">库存发放</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="券名称" prop="name">
          <el-input type="text" v-model="form.name" placeholder="请输入券名称"/>
        </el-form-item>
        <el-form-item label="标题" prop="subTitle">
          <el-input type="text" v-model="form.subTitle" placeholder="请输入标题"/>
        </el-form-item>
        <el-form-item label="图片" prop="imageKey">
          <UploadImg name="imageKey" @getUploadFile="getUploadFile" :uploadUrl="form.imageKey" desc="建议：上传160*160jpg、png、jpeg图片"></UploadImg>
        </el-form-item>
        <el-form-item label="背景图" prop="backImgKey">
          <UploadImg name="backImgKey" :width="325" :height="165" @getUploadFile="getUploadFile" :uploadUrl="form.backImgKey" desc="建议：上传750*330jpg、png、jpeg图片"></UploadImg>
        </el-form-item>
        <el-form-item label="用券时间" prop="effectiveType">
          <el-radio-group v-model="form.effectiveType" :disabled="!!($route.query.copy != 'true' && form.id)">
            <el-radio label="Fixed">固定时间</el-radio>
            <el-radio label="Unfixed">指定时间</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item v-if="form.effectiveType == 'Fixed'" label="" prop="fixedTime">
          <el-date-picker
            v-model="form.fixedTime"
            type="datetimerange"
            range-separator=""
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :picker-options="pickerOptions"
            :disabled="!!($route.query.copy != 'true' && form.id)"
          >
          </el-date-picker>
        </el-form-item>
          <div class="assign-day" v-if="form.effectiveType == 'Unfixed'" style="margin-left: 260px;">
          <el-form-item label="" prop="waitDays" label-width="0">
            <el-input type="text" v-model="form.waitDays" oninput="value=value.replace(/[^\d]/g,'')" :disabled="!!($route.query.copy != 'true' && form.id)">
              <template slot="prepend">领/发后</template>
              <template slot="append">日起</template>
            </el-input>
          </el-form-item>
          <el-form-item label="" prop="days" label-width="0">
            <el-input type="text" v-model="form.days" oninput="value=value.replace(/[^\d]|^0/g,'')" :disabled="!!($route.query.copy != 'true' && form.id)">
              <template slot="append">天内有效</template>
            </el-input>
          </el-form-item>
        </div>
        <!-- <el-form-item v-if="form.effectiveType == 'SameDay' || form.effectiveType == 'NextDay'" label="" prop="days" :label-width="form.effectiveType == 'SameDay' ? '210px' : '350px'" >
          <el-input type="text" v-model="form.days" oninput="value=value.replace(/[^\d]/g,'')"  :disabled="form.id?true:false">
            <template v-if="form.effectiveType == 'SameDay'" slot="prepend">领/发当日起</template>
            <template v-if="form.effectiveType == 'NextDay'" slot="prepend">领/发次日起</template>
            <template slot="append">天内可用</template>
          </el-input>
        </el-form-item> -->

        <div class="store-select">
          <el-form-item label="核销范围" prop="useRangeType">
            <el-radio-group v-model="form.useRangeType">
              <el-radio label="Mall">
                <span>商场核销</span>
                <span v-if="form.useRangeType === 'Mall'" class="desc">{{`（已选${form.mallIds ? form.mallIds.length : 0}个）`}}</span>
              </el-radio>
              <el-radio label="Store">
                <span>店铺核销</span>
                <span v-if="form.useRangeType === 'Store'" class="desc">{{ `（已选${form.storeIds ? form.storeIds.length : 0}个）` }}</span>
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="form.useRangeType === 'Mall'" class="mall-select-box" prop="mallIds" label="" label-width="0">
            <el-select v-model="form.mallIds" placeholder="请选择商场" multiple>
              <el-option v-for="item in mallData" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="form.useRangeType === 'Store'" class="store-select-box" prop="storeIds" label="" label-width="0">
            <el-cascader
              v-model="form.storeIds"
              placeholder="请选择店铺"
              :options="shopTreeData"
              :props="shopCascaderProps"
              clearable
              collapse-tags
              :filterable="true"
              :show-all-levels="false"
            >
            </el-cascader>
          </el-form-item>
        </div>
        <div v-if="form.issueType=='Stock'">
          <el-form-item label="appId" prop="appId" >
            <el-input v-model="form.appId" placeholder="请输入appid" ></el-input>
          </el-form-item>
          <el-form-item label="页面路径" prop="path" >
            <el-input v-model="form.path" placeholder="请输入页面路径"></el-input>
          </el-form-item>
        </div>
        <el-form-item label="使用须知" prop="description">
          <div style="border: 1px solid #ccc; margin-top: 10px;width: calc(60% - 40px);">
            <!-- 工具栏 -->
            <Toolbar
              style="border-bottom: 1px solid #ccc"
              :editor="editor"
              :defaultConfig="toolbarConfig"
            />
            <!-- 编辑器 -->
            <Editor
              style="height: 400px; overflow-y: hidden;"
              :defaultConfig="editorConfig"
              v-model="form.description"
              @onCreated="onCreated"
            />
          </div>
        </el-form-item>
      </div>
    </el-form>

    <div class="footer">
      <el-button @click="onBack" class="mr20">取消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="submitLoading">提交</el-button>
    </div>
  </div>
</template>

<script>
import editor from '@/mixins/editor'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import UploadImg from '@/components/UploadImg/index'
import {api_postGiftCouponAdd,api_putGiftCouponUpdate,api_getGiftCouponDetailV2} from '@/api/market'
import { api_getConfig, api_postFileUpload } from "@/api/common";

export default {
  name: "marketGiftCouponListAdd",
  components: {
    UploadImg,
    Editor,
    Toolbar
  },
  mixins: [ editor ],
  data() {
    const checkImage = (rule, value, callback) => {
      if (!this.form.imageKey) {
        callback(new Error('请上传头图'))
      }else {
        callback()
      }
    }
    const checkBackImg = (rule, value, callback) => {
      if (!this.form.backImgKey) {
        callback(new Error('请上传背景图'))
      }else {
        callback()
      }
    }
    return {
      isAdmin: false, // 是否是超级管理员
      submitLoading: false,
      form: {
        effectiveType: 'SameDay',
        issueType: 'Auto',
      },
      rules: {
        name: [{required: true, message: '请输入券名称'}],
        subTitle: [{required: true, message: '请输入标题'}],
        imageKey: [{ validator: checkImage }],
        backImgKey: [{ validator: checkBackImg }],
        effectiveType: [{required: true, message: '请选择用券时间'}],
        useRangeType: [{required: true, message: '请选择核销范围'}],
        fixedTime: [{required: true, message: '请选择时间'}],
        days: [{required: true, message: '请输入天数'}],
        issueType: [{required: true, message: '请选择券来源'}],
      },

      mallData: [], // 获取商场数据
      shopTreeData: [], // 店铺级联框树形数据
      shopCascaderProps: {
        multiple: true,
        value: "id",
        label: "name",
        emitPath: false,
      }, // 店铺级联框配置项
      pickerOptions:{
        disabledDate (time) {
          return time.getTime() < Date.now()-1 * 24 * 3600 * 1000 // 限制选当前时间之后的时间
        }
      },
    };
  },
  created() {
    if(this.$route.query.id){
    this.getGitftCouponDetail()
    }
    this.isAdmin = JSON.parse(localStorage.getItem('USER_INFO')).admin
    this.getConfigData() // 获取商场、店铺级联框、折扣枚举数据
  },
  methods: {
    // 获取商场、店铺级联框数据
    async getConfigData() {
      let {mall, storeThreeLevel} = await api_getConfig(['mall', 'storeThreeLevel'])
      this.mallData = mall
      this.shopTreeData = storeThreeLevel
    },
    // 获取券详情
    async getGitftCouponDetail() {
      let res = await api_getGiftCouponDetailV2({id: this.$route.query.id})
      this.form = {
        ...res,
        fixedTime: res.startTime && this.$route.query.copy != 'true' ? [res.startTime, res.endTime] : []
      }
    },
    // 点击提交按钮
    onSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          try {
            let params = {
              ...this.form,
              description: this.form.description == '<p><br></p>' ? '' : this.form.description
            }

            if (params.path&&!params.appId) {
               this.$baseMessage('请填写appId', 'error')
               this.submitLoading = false
               return
            }

            // 上传图片
            const imageKey = await this.uploadImg('imageKey')
            imageKey && (params.imageKey = imageKey)

            // 上传背景图
            const backImgKey = await this.uploadImg('backImgKey')
            backImgKey && (params.backImgKey = backImgKey)


            // 处理用券时间---固定时间的时间值
            if (this.form.effectiveType == 'Fixed') {
              params.startTime = this.form.fixedTime ? this.$moment(this.form.fixedTime[0]).valueOf() : null // 券有效期-开始
              params.endTime = this.form.fixedTime ? this.$moment(this.form.fixedTime[1]).valueOf() : null // 券有效期-结束
            }

            delete params.fixedTime
            if (this.$route.query.copy) {
              delete params.id
              delete params.disable
            }
            console.log('params: ', params);
            // return

            const res =  params.id ? await api_putGiftCouponUpdate(params) : await api_postGiftCouponAdd(params)

            console.log('res: ', res);
            this.$baseMessage('操作成功', 'success')
            this.onBack()
            this.submitLoading = false
          } catch (err) {
            console.log('err: ', err);
            this.submitLoading = false
          }
        }
      })
    },

    // 上传图片
    async uploadImg(field) {
      let key = ''
      if (this.form[field] && this.form[field].size) {
        const res = await api_postFileUpload(this.form[field], 'GiftCoupon')
        key = res.key
      } else if (this.$route.query.copy == 'true') {
        let key_src = this.form[field] ? this.form[field].split('.com/') : []
        key = key_src[key_src.length - 1]
      }
      return key
    },

    getUploadFile (file, name) {
      this.form[name] = file
    },

    // 返回
    onBack() {
      this.$router.back(-1)
    },
  },
  watch: {},
  computed: {},
};
</script>

<style lang="scss" scoped>
.market-giftCouponList-add {
  padding: 35px 20px 0 20px;
  padding-bottom: 100px;
  box-sizing: border-box;

  .input-remark {
    height: 17px;
    line-height: 17px;
    font-size: 12px;
    color: #999999;
    position: absolute;
    left: 350px;
    bottom: 0;
  }

  .assign-day {
    display: flex;

    .el-input {
      width: 300px;
    }

    .el-form-item {
      &:last-child {
        .el-input {
          width: 200px;
          margin-left: 5px;
        }
      }
    }
  }

  .base-config {
    margin-top: 20px;
    padding-bottom: 30px;

    .store-select {
      .mall-select-box {
        margin-left: 100px;
        margin-top: -20px;
      }

      .store-select-box {
        // margin-left: 240px;
        margin-left: 210px;
        margin-top: -20px;
      }
    }
  }

  ::v-deep {
    .el-radio-group {
      .el-radio-button__inner {
        height: 34px;
        padding: 0;
        line-height: 34px;
        margin-right: 1px;
        width: 100px;
        border: 0;
      }

      .el-radio-button:first-child {
        .el-radio-button__inner {
          border-radius: 2px 0px 0 0;
        }
      }

      .el-radio-button:last-child {
        .el-radio-button__inner {
          border-radius: 0 2px 0 0;
        }
      }
    }

    .el-input,
    .el-textarea,
    .el-select {
      width: 350px;
    }

    .el-range-editor.el-input__inner {
      width: 350px;
      background: #F2F3F5;
      border: 0;

      input {
        background: #F2F3F5;
        border: 0;
      }
    }

    .el-range-editor.el-input__inner.is-active {
      width: 350px;
      background: #fff;
      border: 1px solid #05C8AF;

      input {
        background: #fff;
        border: 0;
      }
    }

    .desc {
      color: #999;
      font-size: 12px;
    }
  }

  .footer {
    position: fixed;
    bottom: 0;
    padding: 20px 0;
    padding-left: 70px;
    background: #fff;
    width: calc(100vw - #{$base-left-menu-width});
    left: $base-left-menu-width;
    z-index: 999;
  }
}
</style>
<style src="@wangeditor/editor/dist/css/style.css"></style>
